module.exports = __webpack_public_path__ + "assets/img/error-goods.91a47fc2.jpg";